import * as React from "react";
import { ActionType } from "../../../../../../../react-core/Flux/ActionType";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { AccountAdviceType } from "../../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { AssetClassType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ModelPortfolioTabType } from "../../../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { OrderDirection } from "../../../../../../../Wrap/Constants/Enums/Domain/OrderDirection";
import { OrderType } from "../../../../../../../Wrap/Constants/Enums/Domain/OrderType";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { AccountStatus } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { InstrumentSearchQuery } from "../../../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { PortfolioCashDetail } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Cash/PortfolioCashDetail";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { DecisionMaker } from "../../../../../../Shared/IST/Components/DecisionMaker";
import { ReuseInvesment } from "../../../../../../Shared/IST/Components/ReuseInvesment";
import { SearchTabs } from "../../../../../../Shared/IST/Components/Shared/SearchTabs";
import { ProcessType, reuseType } from "../../../../../../Shared/IST/Resource/Content";
import { SelectedInvestmentStore } from "../../../../../../Shared/IST/Store/Variable";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { QuantitySwitch } from "../../../../../../Shared/QuantitySwitch/QuantitySwitch";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../../../Actions/Action";
import { InvestmentsAction } from "../../../PortfolioDashboard/Components/Investment/Action/InvestmentAction";
import { BuySellAllocationTable } from "../../../Common/BuySellInvestmentSelection/BuySellAllocationTable";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import {
    clearAllocation,
    initInstrumentList,
    transformNewItem,
} from "../../../Common/BuySellInvestmentSelection/BuySellAllocationTableHelper";
import { OrderSetupReview } from "../../../Common/Review/Component/OrderSetupReview";
import { hasDecisionMaker } from "../../../Switch/Resource/Content";
import { BuyAction } from "../../Action/BuyAction";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { ClientAccountStore, UserStore, TreasuredAssetsStore } from "../../../../../Stroes/Variable";
import { PropositionInvestmentConfig } from "../../../../../../../Wrap/Models/Domains/Account/PropositionInvestmentConfig";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";
import { CompanyWizardAction } from "../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { DepositProductsQuery } from "../../../../../../../Wrap/Models/Domains/Investment/DepositProductsQuery";
import { DepositProduct } from "../../../../../../../Wrap/Models/Domains/Investment/DepositProduct";
import { InvestmentType } from "../../../../../../../Wrap/Constants/Enums/InvestmentType";
import { InvestorType } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { TradableInvestment } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/TradableInvestment";
import { ResultPageModel } from "../../../../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { BatchType } from "../../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";

interface IBuyInvestmentProps extends IProcessComponentProps {
    type: SubAccountType;
    isReview: boolean;
}

interface IBuyInvestmentState {
    isLoading: boolean;
    clientHoldings: any;
    orderType: OrderType;
    availableFunds: number;
    status: AccountStatus;
    investmenPermission: PropositionInvestmentConfig[];
    userInfo: User;
    treasuredAssetProductIds: Array<number>;
    companyServicePropostion: ServiceProposition[];
    depositProducts: Record<number, DepositProduct>;
    cashInstrument: Instrument;
    selectedTab: InvestmentType;
    invalidInsuredFunds: string[];
}

export class BuyInvestment extends ProcessComponent<IBuyInvestmentProps, IBuyInvestmentState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            isLoading: true,
            clientHoldings: null,
            orderType:
                props.data.InvestmentList && props.data.InvestmentList.length > 0
                    ? props.data.InvestmentList[0].Type
                    : OrderType.Percentage,
            availableFunds: 0,
            status: null,
            investmenPermission: [],
            treasuredAssetProductIds: null,
            companyServicePropostion: [],
            depositProducts: [],
            cashInstrument: null,
            selectedTab: InvestmentType.HubPortfolios,
            invalidInsuredFunds: [],
        };
        this.subscribeToStore(SelectedInvestmentStore, () => this.onStoreChange());
    }

    private getTreasuredAssets() {
        const _treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();

        if (!_treasuredAssetProductIds) {
            const params = getQueryParameters();

            Action.getSubAccountTreasuredAssetsProductIds(params["subaccounthierarchyid"], (data: Array<number>) => {
                this.setState({ treasuredAssetProductIds: data });
            });
        } else {
            this.setState({ treasuredAssetProductIds: _treasuredAssetProductIds });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.getTreasuredAssets();
        InvestmentSelectionAction.setIsUnderTransfer(true);
        const params = getQueryParameters();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        if (clientAccount?.AccountServicePropositionId) {
            InvestmentSelectionAction.getInvestmentPermission(clientAccount.AccountServicePropositionId, (res) => {
                const newRes = [...res];
                const elementIndex = newRes.findIndex((x) => x.InvestmentTypeId == InvestmentType.CashDeposits);
                if (elementIndex !== -1) {
                    if (
                        !(
                            clientAccount.InvestorType == InvestorType.Individ ||
                            clientAccount.InvestorType == InvestorType.Individual ||
                            clientAccount.InvestorType == InvestorType.Joint ||
                            clientAccount.InvestorType == InvestorType.JointIndividual
                        )
                    )
                        newRes[elementIndex].Enable = false;
                }
                this.setState({ investmenPermission: newRes });
            });
        }
        if (clientAccount?.Company) {
            CompanyWizardAction.getViewCompany(clientAccount?.Company, (res) => {
                this.setState({ companyServicePropostion: res?.ServicePropositions });
            });
        }
        if (!this.props.data.InvestmentList) {
            this.props.onChange({ InvestmentList: [] });
        }
        BuyAction.getReuseHoldings(
            params["hierarchyid"],
            params["subaccounthierarchyid"],
            this.props.data.BatchId,
            (data: ClientTradableInvestments) => this.populateReuseHoldings(data, params)
        );

        this.fetchDepositProductDetails(this.props.data.InvestmentList);

        Action.getPortfolioCash(
            params["subaccounthierarchyid"],
            JsonDateParser.toJsonDateNoOffset(new Date()),
            (result: PortfolioCashDetail[]) => {
                if (result.length > 0) {
                    this.setState({ availableFunds: result[0].AvailBalance });
                }
            }
        );
    }

    componentWillUnmount() {
        InvestmentSelectionAction.setIsUnderTransfer(false);
    }

    async populateReuseHoldings(data: ClientTradableInvestments, params): Promise<void> {
        this.setState({ cashInstrument: data.CashInstrument });

        const individual = data.CurrentIndividualHoldings?.filter((ele) => ele.DisplayName != "GBP Cash");
        data.TargetAllocations = data.TargetAllocations?.filter((ele) => ele.DisplayName != "GBP Cash");

        if (individual.length == 0) {
            this.setState({
                isLoading: false,
            });
        }

        await this.replaceCashProductInstancesWithTemplates(individual);

        let ids = Array.from(
            new Set(
                individual
                    .map((ele) => ele.ProductId)
                    .concat(data.CurrentModelHoldings.map((ele) => ele.ProductId))
                    .concat(data.TargetAllocations.map((ele) => ele.ProductId))
            )
        );

        const query: InstrumentSearchQuery = {
            ProductWrapperTypes: [this.props.type],
            ProductIds: ids,
            CanBeBought: true,
            ResultsPerPage: ids.length,
            ServiceProposition: data.AccountServiceProposition,
        };
        let currentAssets = [];
        let targetAllocation = [];

        InvestmentSelectionAction.searchInstruments(query, params["subaccounthierarchyid"], (result: Instrument[]) => {
            result.forEach((ele) => {
                const target = data.TargetAllocations.find((item) => item.ProductId == ele.ProductId);

                const obj = data.CurrentIndividualHoldings.find((item) => item.ProductId == ele.ProductId);
                const model = data.CurrentModelHoldings.find((item) => item.ProductId == ele.ProductId);

                if (obj) {
                    currentAssets = currentAssets.concat(
                        transformNewItem(
                            [{ Investment: obj }],
                            this.state.orderType,
                            OrderDirection.Buy,
                            this.props.data.TotalValue
                        )
                    );
                } else if (model) {
                    currentAssets = currentAssets.concat(
                        transformNewItem(
                            [{ Investment: model }],
                            this.state.orderType,
                            OrderDirection.Buy,
                            this.props.data.TotalValue
                        )
                    );
                }

                if (target) {
                    const weighting = target ? target.Weighting : 0;
                    targetAllocation = targetAllocation.concat(
                        transformNewItem(
                            [
                                {
                                    Investment: {
                                        ...target,
                                        Type: null,
                                        Allocation: Number(weighting.toFixed(2)),
                                    },
                                },
                            ],
                            OrderType.Percentage,
                            OrderDirection.Buy,
                            this.props.data.TotalValue,
                            true,
                            true
                        )
                    );
                }
            });

            this.setState({
                isLoading: false,
                status: data.AccountStatus,
                clientHoldings: { currentAssets: currentAssets, targetAllocation: targetAllocation },
            });

            this.props.onChange({
                AccountAdviceType: data.ClientDetail
                    ? data.ClientDetail.AccountAdviceType
                    : AccountAdviceType.NotSpecified,
            });
        });
    }

    fetchDepositProductDetails(investmentList) {
        const depositProductIds: number[] = Array.from(
            new Set(
                investmentList
                    .filter((row) => row.Instrument.Type === ProductType.CashProduct)
                    .map((row) => row.Instrument.ProductId)
            )
        );

        if (depositProductIds.length === 0) {
            return;
        }

        const clientAccount = ClientAccountStore.getClientAccountInfo();

        const query: DepositProductsQuery = {
            ProductIds: depositProductIds,
            ServiceProposition: clientAccount.AccountServicePropositionId,
            ResultsPerPage: depositProductIds.length,
        };

        InvestmentSelectionAction.searchDepositProducts(
            query,
            getQueryParameters()["hierarchyid"],
            (data: ResultPageModel<DepositProduct>) => {
                const depositProducts: Record<number, DepositProduct> = data.Results.reduce<
                    Record<number, DepositProduct>
                >((acc, product) => {
                    acc[product.ProductId] = product;
                    return acc;
                }, {});

                this.setState({ depositProducts });
            },
            (err) => {
                console.error("Failed to fetch deposit products:", err);
            }
        );
    }

    async replaceCashProductInstancesWithTemplates(
        investments: TradableInvestment[]
    ): Promise<ResultPageModel<DepositProduct>> {
        const cashProductInstanceIds: number[] = Array.from(
            new Set(investments.filter((row) => row.Type === ProductType.CashProduct).map((row) => row.ProductId))
        );

        if (cashProductInstanceIds.length === 0) return;

        const clientAccount = ClientAccountStore.getClientAccountInfo();

        const query: DepositProductsQuery = {
            ProductIds: cashProductInstanceIds,
            ServiceProposition: clientAccount.AccountServicePropositionId,
            ResultsPerPage: cashProductInstanceIds.length,
        };

        return new Promise((resolve) =>
            InvestmentSelectionAction.searchDepositProducts(
                query,
                getQueryParameters()["hierarchyid"],
                (data: ResultPageModel<DepositProduct>) => {
                    investments
                        .filter((x) => x.Type === ProductType.CashProduct)
                        .forEach((x) => {
                            const cashProduct: DepositProduct = data.Results.find((y) => y.ProductId === x.ProductId);
                            x.ProductId = cashProduct.TemplateProductId;
                            x.InstrumentCode = cashProduct.TemplateProductCode;
                        });
                    resolve(data);
                },
                (err) => {
                    console.error("Failed to fetch cash products:", err);
                }
            )
        );
    }

    isValid() {
        if (this.state.isLoading) {
            return false;
        }
        if (RestrictionStore.buyDisabled()) {
            return false;
        }
        if (this.state.invalidInsuredFunds && this.state.invalidInsuredFunds.length > 0) {
            return false;
        }
        const flag = super.isValid();
        if (this.state.status != AccountStatus.Active) {
            this.props.showErrorMsgPopUp(["The account is inactive!"]);
        }
        const hasNoCash = this.state.availableFunds == 0;
        if (hasNoCash) {
            this.props.showErrorMsgPopUp(["Order cannot be placed due to Insufficient Cash!"]);
        }

        const isValid = flag && this.state.status == AccountStatus.Active && !hasNoCash;

        if (isValid) {
            const params = getQueryParameters();
            InvestmentsAction.setSubAccountTreasuredAssetsProductIds(
                params["subaccounthierarchyid"],
                this.state.treasuredAssetProductIds || []
            );
        }

        return isValid;
    }

    onStoreChange() {
        const { InvestmentList } = this.props.data;

        if (SelectedInvestmentStore.getActionType() != ActionType.Success) return;

        const modelType = SelectedInvestmentStore.getData()[0].ModelType;

        const newItem = transformNewItem(
            SelectedInvestmentStore.getData(),
            modelType == ModelPortfolioTabType.AdviserModel ? OrderType.Percentage : this.state.orderType,
            OrderDirection.Buy,
            this.props.data.TotalValue,
            modelType == ModelPortfolioTabType.AdviserModel ? true : false
        );

        const _data = newItem.filter((item) =>
            InvestmentList.every(
                (ele) =>
                    ele.InstrumentCode !== item.Instrument.InstrumentCode &&
                    ele.InstrumentCode !== item.Instrument.ProductCode
            )
        );

        const investmentList = modelType == ModelPortfolioTabType.AdviserModel ? newItem : InvestmentList.concat(_data);
        this.fetchDepositProductDetails(investmentList);
        this.validateInsuredFunds(investmentList);

        this.props.onChange({
            InvestmentList: investmentList,
        });
    }

    //Insured funds are only available for SIPP
    private validateInsuredFunds(investmentList) {
        if (SubAccountTypeHelper.isSIPP(this.props.type)) return;

        const _listOfInsuredFunds = investmentList
            .filter((inv) => inv.Instrument.InsuredFund === true)
            .map((p) => p.Instrument.InstrumentCode);

        this.setState({ invalidInsuredFunds: _listOfInsuredFunds });
    }

    private applyEven = (v) => {
        if (!v) {
            return;
        }
        const { InvestmentList } = this.props.data;
        const percentage = Number((100 / InvestmentList.length).toFixed(2));
        const lastPercentage = Number((100 - percentage * (InvestmentList.length - 1)).toFixed(2));
        const _data = InvestmentList.map((ele, index) => {
            return {
                ...ele,
                OrderPercentage: index == InvestmentList.length - 1 ? lastPercentage : percentage,
                OrderValue: this.props.data.TotalValue * percentage * 0.01,
                BuyOrSell: OrderDirection.Buy,
            };
        });
        this.props.onChange({ InvestmentList: _data });
    };

    private onUnderlyingToggle(isToggle, index, row) {
        const _data = this.props.data.InvestmentList.concat();
        if (isToggle) {
            const item = _data[index];
            _data[index].isToggle = isToggle;
            if (item.underlying) {
                this.props.onChange({ InvestmentList: _data });
            } else {
                if (row.modelPortfolioType) {
                    InvestmentSelectionAction.getUnderlying(
                        row.Instrument.ProductId,
                        ModelPortfolioTabType.HubModel,
                        (data) => {
                            _data[index].underlying = data;
                            this.props.onChange({ InvestmentList: _data });
                        }
                    );
                } else {
                    InvestmentsAction.getInvestmentsModelSingle(
                        getQueryParameters()["subaccounthierarchyid"],
                        row.Instrument.InstrumentCode,
                        JsonDateParser.toJsonDateNoOffset(new Date()),
                        AssetClassType.Tier1,
                        (result) => {
                            _data[index].underlying = { ModelPortfolioProducts: [] };
                            result.forEach((ele) => {
                                ele.Investments.forEach((item) => {
                                    _data[index].underlying.ModelPortfolioProducts.push({
                                        name: item.DisplayName,
                                        targetAllocation: "-",
                                    });
                                });
                            });
                            this.props.onChange({ InvestmentList: _data });
                        }
                    );
                }
            }
        } else {
            _data[index].isToggle = isToggle;
            this.props.onChange({ InvestmentList: _data });
        }
    }

    private onReuseInvestment(v) {
        const { onChange } = this.props;
        if (v == reuseType.no) {
            onChange({ InvestmentList: [] });
        } else if (this.state.clientHoldings) {
            if (v == reuseType.useTargetAllocation) {
                this.setState({ orderType: OrderType.Percentage });
                onChange({ InvestmentList: this.state.clientHoldings.targetAllocation });
            } else if (v == reuseType.useCurrentAssets) {
                this.setState({ orderType: OrderType.Percentage });
                onChange({ InvestmentList: this.state.clientHoldings.currentAssets });
                this.fetchDepositProductDetails(this.state.clientHoldings.currentAssets);
            }
        }
    }

    private onTreasuredAssetChange = (v: boolean, productId: number) => {
        const treasuredAssets = new Set(this.state.treasuredAssetProductIds);
        let stateHasChanged = false;

        if (treasuredAssets.has(productId)) {
            if (!v) {
                treasuredAssets.delete(productId);
                stateHasChanged = true;
            }
        } else {
            if (v) {
                treasuredAssets.add(productId);
                stateHasChanged = true;
            }
        }

        if (stateHasChanged) {
            this.setState({ treasuredAssetProductIds: Array.from(treasuredAssets) });
        }
    };

    private setTab(v) {
        this.setState({ selectedTab: v });
        this.upateInvestmentList(v);
    }

    private upateInvestmentList(v) {
        const { cashInstrument } = this.state;

        if (v == InvestmentType.AdviserPortfolios) {
            if (this.props.data.InvestmentList.length == 0) {
                this.props.onChange({
                    InvestmentList: [initInstrumentList(cashInstrument, this.state.orderType, OrderDirection.Buy)],
                });
            } else if (
                !this.props.data.InvestmentList.find((x) => x.Instrument.ProductId == cashInstrument.ProductId)
            ) {
                this.props.onChange({
                    InvestmentList: [
                        initInstrumentList(cashInstrument, this.state.orderType, OrderDirection.Buy),
                    ].concat(this.props.data.InvestmentList),
                });
            }
        } else {
            if (this.props.data.InvestmentList.find((x) => x.Instrument.ProductId == cashInstrument.ProductId)) {
                const newItems = this.props.data.InvestmentList.filter(
                    (item) => item.Instrument.ProductId !== cashInstrument.ProductId
                );
                this.props.onChange({
                    InvestmentList: newItems,
                });
            }
        }
    }

    private amendPercentageOrderValues(data: any) {
        data.InvestmentList = data.InvestmentList.map((ele) => {
            if (ele.OrderValue === 0 && ele.OrderPercentage != 0) {
                return {
                    ...ele,
                    OrderValue: ele.OrderPercentage * data.TotalValue * 0.01,
                };
            }
            return ele;
        });
    }

    public render(): JSX.Element {
        const { data, type, onChange } = this.props;
        const params = getQueryParameters();
        const hasTargetAllocation = data.InvestmentList && data.InvestmentList.some((ele) => ele.isTargetAllocation);
        const clientAccount = ClientAccountStore.getClientAccountInfo();

        if (this.state.orderType === OrderType.Percentage && data.InvestmentList && data.TotalValue) {
            this.amendPercentageOrderValues(data);
        }

        let restrictedMessage = "An account with suspended or restricted activities cannot setup buy investments";

        let notAvailableToBuyMessage =
            "The following Instrument(s): " +
            this.state.invalidInsuredFunds.join(", ") +
            " cannot be brought forward for this product. Please select a replacement or" +
            " increase outstanding allocation amount on remaining investments.";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        return (
            <div className="ist-wrap">
                <h2 className="mb-18">
                    <span>Buy investments</span>
                </h2>
                {RestrictionStore.buyDisabled() && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                <OrderSetupReview data={data} subAccountType={type} process={ProcessType.Buy} colNum={1} />
                <NumberTextBoxEditor
                    label="Available funds"
                    cssWrapper="control-size-245"
                    disabled
                    value={this.state.availableFunds}
                />
                <MoneyTextBoxEditor
                    label="Total order value"
                    cssWrapper="control-size-245"
                    currency={CurrencyCode.GBP}
                    value={data.TotalValue}
                    onChange={(v) => {
                        let _data = data.InvestmentList;
                        if (this.state.orderType == OrderType.Percentage) {
                            _data = _data.map((ele) => {
                                return {
                                    ...ele,
                                    OrderValue: ele.OrderPercentage * v * 0.01,
                                    BuyOrSell: OrderDirection.Buy,
                                };
                            });
                        }
                        onChange({ TotalValue: v, InvestmentList: _data });
                    }}
                    maxNumberOfDecimalPlaces={{
                        errorMessage: "only allow two decimal places",
                        value: 2,
                    }}
                    atMost={{
                        value: this.state.availableFunds,
                        errorMessage: "Value can not be larger than Available funds",
                    }}
                    moreThan={{
                        value: 0,
                        errorMessage: "Value must larger than 0",
                    }}
                    required="Please enter"
                />
                <hr />
                <PartLoading isLoading={this.state.isLoading}>
                    <ReuseInvesment
                        onRef={(ref) => this.appendChild(ref)}
                        data={data}
                        onChange={() => {}}
                        onReuseInvesment={(v) => this.onReuseInvestment(v)}
                    />
                    <SearchTabs
                        hiercharyId={params["subaccounthierarchyid"]}
                        product={type}
                        data={data.InvestmentList}
                        isUnderTransfer={false}
                        isUnit={this.state.orderType == OrderType.Quantity}
                        investmentPermission={this.state.investmenPermission}
                        accountServiceProposition={clientAccount?.AccountServicePropositionId}
                        canBeBought={true}
                        canBeSold={false}
                        companyServiceProposition={this.state.companyServicePropostion}
                        batchType={data.BatchType}
                    />
                    <div className="row mt-5">
                        <div className="col-6">
                            {this.state.orderType == OrderType.Percentage && !hasTargetAllocation && (
                                <CheckboxEditor
                                    label="Apply even weighting"
                                    cssWrapper="square-checkbox block mt-19"
                                    onChange={(v) => this.applyEven(v)}
                                />
                            )}
                        </div>
                        <div className="col-6 col-right">
                            {!hasTargetAllocation && (
                                <QuantitySwitch
                                    type={this.state.orderType}
                                    onChange={(v) => {
                                        onChange({ InvestmentList: clearAllocation(data.InvestmentList, v) });
                                        this.setState({ orderType: v });
                                    }}
                                    hasModel={
                                        data.InvestmentList &&
                                        data.InvestmentList.some(
                                            (ele) =>
                                                ele.Instrument &&
                                                [
                                                    ProductType.ManagedModelPortfolio,
                                                    ProductType.TailoredModelPortfolio,
                                                ].includes(ele.Instrument.Type)
                                        )
                                    }
                                />
                            )}
                        </div>
                    </div>
                    <BuySellAllocationTable
                        onToggle={(isToggle, index, rowData) => this.onUnderlyingToggle(isToggle, index, rowData)}
                        data={data.InvestmentList}
                        orderType={this.state.orderType}
                        onChange={(list) => {
                            let _totalValue = data.TotalValue;
                            const changedObject = {
                                InvestmentList: list.map((ele) => {
                                    return { ...ele, Type: this.state.orderType };
                                }),
                                TotalValue: data.TotalValue,
                            };
                            if (this.state.orderType != OrderType.Percentage) {
                                _totalValue = 0;
                                // calculate total value in real time
                                list.forEach((ele) => {
                                    _totalValue += ele?.OrderValue || 0;
                                });
                            }
                            changedObject.TotalValue = _totalValue;
                            onChange(changedObject);
                        }}
                        depositProducts={this.state.depositProducts}
                        process={ProcessType.Buy}
                        onRef={(ref) => this.appendChild(ref)}
                        totalValue={data.TotalValue}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        onTreasuredAssetChange={this.onTreasuredAssetChange}
                        ChecktreasuredAsset={this.state.treasuredAssetProductIds}
                        batchType={data.BatchType}
                    />

                    {this.state.invalidInsuredFunds.length > 0 && (
                        <Alert alertType={AlertType.Error} message={notAvailableToBuyMessage} />
                    )}

                    {hasDecisionMaker(data.InvestmentList) && (
                        <DecisionMaker
                            onRef={(ref) => this.appendChild(ref)}
                            data={data}
                            onChange={(v) => onChange(v)}
                            clAccountId={params["claccountid"]}
                            headAccountHierarchyId={clientAccount?.HierarchyId}
                            companyCode={clientAccount?.Company}
                            accountAdviceType={
                                clientAccount?.Discretionary
                                    ? AccountAdviceType.Discretionary
                                    : AccountAdviceType.NonDiscretionary
                            }
                            showErrorMsgPopUp={(msg, now) => this.props.showErrorMsgPopUp(msg, now)}
                        />
                    )}
                </PartLoading>
            </div>
        );
    }
}
